import React, { Component } from 'react';
import './NewSortPage.css';
import '@shopify/polaris/dist/styles.css';
import {AppProvider} from '@shopify/polaris';
import Sort from '../components/Sort';
import { getFetch } from '../helpers/request';

interface NewSortPageProps { }

interface NewSortPageState {
  shopOrigin: string
}

class NewSortPage extends Component <NewSortPageProps, NewSortPageState> {

  constructor(props: NewSortPageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    //check if log in
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => res.json()
    ).then(data => {
      this.setState({ shopOrigin: data.shop_origin })
    }).catch(err => {

    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Sort shopOrigin={this.state.shopOrigin} type="new"></Sort>
      </AppProvider>
    );
  }
}

export default NewSortPage;
